import { STATUS_DICTIONARY } from '../constants/status-dictionary.constant';
import { isStringEqual } from './is-string-equal.handle';

export const defaultValueSelect = (status, claimResponse) => {
	if (status === STATUS_DICTIONARY.close && isStringEqual(claimResponse) === true) {
		return claimResponse;
	}
	if (status === STATUS_DICTIONARY.close) {
		return 'Otro';
	}
	return null;
};
